<template>
  <div>
    <div
      v-if="dialogPlayground"
      class="playground-box"
    >
      <div class="playground-content">
        <div style="display:flex;">
          <div style="flex: 1"/>
          <div
            v-if="idFuncionalidade"
            style="font-size: 20px; cursor:pointer; font-weight: bolder"
            @click="dialogPlayground = false"
          >
            <i
              class="el-icon-close"
            />
          </div>
        </div>
        <div class="box-border">
          <el-row
            :gutter="20"
          >
            <!-- Title -->
            <el-col
              :span="22"
              style="margin-bottom: 5px;"
            >
              <h3>Playground de Funcionalidades</h3>
            </el-col>

            <el-col
              :span="16"
              style="margin-bottom: 5px;"
            >
              Bundle Web
              <el-input
                v-model="myBundleWeb"
                label="Bundle Web"
                placeholder="br.com.mobilesaude.plataformatesting"
                size="medium"
              />
            </el-col>

            <el-col
              :span="16"
              style="margin-bottom: 5px;"
            >
              Token
              <el-input
                v-model="token"
                label="Token"
                placeholder="token"
                size="medium"
              />
            </el-col>

            <el-col
              v-if="token"
              :span="16"
              style="margin-bottom: 5px;"
            >
              Payload Usuário
              <el-input
                v-model="payloadCompleto"
                label="JSON"
                placeholder="{}"
                rows="10"
                size="medium"
                type="textarea"
              />
            </el-col>

            <el-col
              :span="16"
              style="margin-bottom: 5px;"
            >
              ConfigJson
              <el-input
                v-model="configJson"
                label="JSON"
                placeholder="{}"
                rows="4"
                size="medium"
                type="textarea"
              />
            </el-col>

            <el-col
              :span="16"
              style="margin-bottom: 5px;"
            >
              <el-checkbox v-model="barramentoLocal">
                <span>Barramento Local</span>
              </el-checkbox>
            </el-col>
            <!-- Create -->
            <el-col
              :span="6"
              class="text-right"
              style="margin-bottom: 5px;"
            >
              <el-button
                plain
                size="mini"
                style="color:white"
                type="primary"
                @click="aplicarBundle"
              >
                Aplicar Bundle
              </el-button>
            </el-col>
          </el-row>
        </div>

        <div
          v-if="showFuncionalidades"
          class="box-border"
        >
          <el-row
            :gutter="20"
          >
            <!-- Title -->
            <el-col
              :lg="22"
              :md="22"
              :sm="10"
              :xl="22"
              :xs="10"
              style="margin-bottom: 5px;"
            >
              <h3>Nome da aplicação: {{ aplicacao.appName }}</h3>
            </el-col>

            <!-- Funcionalidade -->
            <el-col
              :span="16"
              style="margin-bottom: 5px;"
            >
              Funcionalidade
              <el-select
                v-model="idFuncionalidade"
                class="form-select"
                data-vv-as="funcionalidades"
                filterable
                name="funcionalidade"
                placeholder="funcionalidade..."
                size="mini"
                value-key="funcionalidade"
              >
                <el-option
                  v-for="item in funcionalidades"
                  :key="item.id"
                  :label="item.nome"
                  :value="item.id"
                >
                  {{ item.nome }}
                </el-option>
              </el-select>
            </el-col>

            <!-- Create -->
            <el-col
              :span="6"
              class="text-right"
              style="margin-bottom: 5px;"
            >
              <el-button
                plain
                size="mini"
                style="color:white"
                type="primary"
                @click="aplicarFuncionalidade"
              >
                Abrir Funcionalidade
              </el-button>
            </el-col>

            <el-col
              :span="6"
              class="text-right"
              style="margin-bottom: 5px;"
            >
              <el-button
                plain
                size="mini"
                @click="fecharFuncionalidade"
              >
                Fechar Funcionalidade
              </el-button>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <div
      class="playground-btn"
      @click="dialogPlayground = true"
    >
      <i class="el-icon-s-tools"/>
    </div>

    <div
      v-if="renderFuncionalidade"
      style="max-width: 1100px; margin: 0 auto; border: 1px solid #cccccc"
    >
      <router-view/>
    </div>
    <div
      v-if="paths[1] === 'filtros'"
      class="box-border"
    >
      <FilterDialogTest/>
    </div>
  </div>
</template>

<script>
import { ConfiguradorResource, PlataformaBeneficiarioResource } from '@/API'
import { mapGetters, mapMutations, mapState } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import FilterDialogTest from '@/views/filterDialogTest/FilterDialogTest'

const funcAcesso = [{
  id: 9,
  nome: 'Login'
}, {
  id: 134,
  nome: 'Primeiro Acesso'
}, {
  id: 137,
  nome: 'Recuperar Senha'
}, {
  id: 138,
  nome: 'Trocar Senha'
}, {
  id: 141,
  nome: 'Elegibilidade'
}, {
  id: 49,
  nome: 'Meus Protocolos'
}]

const playgroundSessionKey = 'playgroundSessionKey'

export default {
  name: 'Playground',
  components: { FilterDialogTest },
  data () {
    return {
      component: null,
      loading: false,
      loadingMessage: '',
      myBundleWeb: '',
      showFuncionalidades: false,
      idFuncionalidade: '',
      renderFuncionalidade: false,
      dialogPlayground: true,
      payloadCompleto: '',
      configJson: '{}',
      barramentoLocal: false
    }
  },
  computed: {
    ...mapFields('Login', ['token', 'user']),
    ...mapState('SetupApp', ['bundleWeb', 'bundle']),
    ...mapGetters('SetupApp', ['dashBoard', 'tabBar', 'aplicacao']),
    paths () {
      return (String.prototype.split.call(this.$route.path, ['/'])).filter((p) => p !== '')
    },
    funcionalidades () {
      if (!this.myBundleWeb) {
        return []
      }
      const dashBoard = this.dashBoard
        .reduceRight((accumulator, currentValue) => {
          if (currentValue.tipo === 'grupo') {
            if (currentValue.funcionalidades) {
              return currentValue.funcionalidades.concat((accumulator.funcionalidades || accumulator))
            }
            return accumulator
          }

          if (Array.isArray(accumulator)) {
            return accumulator.concat(currentValue)
          }

          return ([accumulator]).concat(currentValue)
        })
      return dashBoard.concat(this.tabBar).concat(funcAcesso)
    }
  },
  created () {
    if (this.bundleWeb) {
      this.myBundleWeb = this.bundleWeb
    }
    setTimeout(this.getPlaygroundSession, 500)
  },
  methods: {
    ...mapMutations('Login', ['SET_BENEFICIARIO']),
    ...mapMutations('SetupApp', ['SET_CONFIG', 'SET_ESQUEMA_DE_COR']),
    setPlaygroundSession () {
      window.sessionStorage.setItem(playgroundSessionKey, JSON.stringify({
        myBundleWeb: this.myBundleWeb,
        token: this.token,
        idFuncionalidade: this.idFuncionalidade,
        barramentoLocal: this.barramentoLocal
      }))
    },
    getPlaygroundSession () {
      const playgroundSession = window.sessionStorage.getItem(playgroundSessionKey)
      if (playgroundSession) {
        const { myBundleWeb, token, idFuncionalidade, barramentoLocal } = JSON.parse(playgroundSession)
        this.myBundleWeb = myBundleWeb
        this.token = token
        this.idFuncionalidade = idFuncionalidade
        this.barramentoLocal = barramentoLocal
      }
    },
    async loadAppSetup () {
      let json = {}
      try {
        json = JSON.parse(this.configJson)
      } catch (ignored) {
        json = {}
      }

      const result = await ConfiguradorResource.getSetupApp({
        bundleWeb: this.myBundleWeb,
        instanciaAplicacao: json.instanciaAplicacao
      })

      if (!result) {
        return false
      }

      if (this.barramentoLocal) {
        Object.keys(result.aplicacao.rotas).forEach((key) => {
          result.aplicacao.rotas[key].rota = result.aplicacao.rotas[key].rota
            .replace('https://api-testing.sandbox.mosiaomnichannel.com.br', 'http://localhost:3120')
        })
      }

      this.SET_CONFIG({
        config: result,
        bundleWeb: this.myBundleWeb,
        frameId: 'frameId',
        json
      })

      if (this.token && !this.payloadCompleto) {
        const payloadBeneficiario = await PlataformaBeneficiarioResource.carregar()
        if (payloadBeneficiario.code !== 401) {
          this.payloadCompleto = JSON.stringify(payloadBeneficiario, null, 2)
        }
      }

      if (this.payloadCompleto) {
        this.SET_BENEFICIARIO(JSON.parse(this.payloadCompleto))
      }

      const esquemaCor = (this.user || {}).esquemaCor
      await this.aplicarEsquemaCor(esquemaCor, this.bundle, this.bundleWeb)

      this.setPlaygroundSession()
      return true
    },
    async aplicarBundle () {
      if (!await this.loadAppSetup()) {
        return false
      }

      this.showFuncionalidades = true
      this.renderFuncionalidade = false
      try {
        await this.$router.replace(`/playground/`)
      } catch (ignored) {}
    },
    async aplicarFuncionalidade () {
      if (!this.idFuncionalidade) {
        return
      }

      try {
        await this.$router.replace(`/playground/${this.idFuncionalidade}`)
      } catch (ignored) {
        await this.$router.replace(`/playground/`)
        await this.$router.replace(`/playground/${this.idFuncionalidade}`)
      }

      this.renderFuncionalidade = true
      this.dialogPlayground = false
      this.setPlaygroundSession()
    },
    async fecharFuncionalidade () {
      try {
        await this.$router.replace(`/playground/`)
      } catch (ignored) {}

      this.renderFuncionalidade = false
    },
    async aplicarEsquemaCor (esquemaCor, bundle, bundleWeb) {
      try {
        const res = await ConfiguradorResource.getEsquemaCor({
          bundle,
          bundleWeb,
          esquemaCor
        })
        this.SET_ESQUEMA_DE_COR(res)
      } catch (ignored) {}
    }
  }
}
</script>

<style scoped>
.box-border {
  border: 1px solid black;
  margin-bottom: 20px;
  padding: 20px;
}

.playground-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 50px;
  width: 50px;
  border: 1px solid #000000;
  opacity: 0.4;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 40px;
  color: red;
  z-index: 1999;
}

.playground-btn :hover {
  opacity: 1;
}

.playground-box {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.2);
}

.playground-content {
  min-width: 600px;
  padding: 20px;
  background: #FFFFFF;
  border: 1px solid #000000;
}
</style>
